"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExecutionProvider;
function ExecutionProvider(execution) {
  return function (context) {
    context.execution = execution;

    return context;
  };
}
//# sourceMappingURL=Execution.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/function-tree/lib/providers/Execution.js
// module id = 711
// module chunks = 0